import React from 'react';
import { View } from 'react-native';

import Text from '../../components/text/Text';
import { useThemedStyles } from '../../hooks/useThemedStyles';

/**
 * PageHeading: screen title block with an optional action beside it, for
 * screens that bring their own list (Screen `scroll={false}`) or need a
 * button next to the title ("Tickets" + "New ticket").
 * Props:
 * - title (string), subtitle (string or node)
 * - action: node on the right, usually a SecondaryButton
 * - style
 */
const PageHeading = ({ title, subtitle, action, style }) => {
	const styles = useThemedStyles(createStyles);

	return (
		<View style={[styles.row, style]}>
			<View style={styles.text}>
				<Text style={styles.title} accessibilityRole="header">{title}</Text>
				{Boolean(subtitle) && <Text style={styles.subtitle}>{subtitle}</Text>}
			</View>
			{Boolean(action) && <View style={styles.action}>{action}</View>}
		</View>
	);
};

const createStyles = ({ ui: { colors, type, space } }) => ({
	row: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: space.md,
	},
	text: {
		flex: 1,
		minWidth: 0,
		gap: 6,
	},
	title: {
		...type.title,
		color: colors.text,
	},
	subtitle: {
		...type.bodySmall,
		color: colors.textSecondary,
	},
	action: {
		flexShrink: 0,
		maxWidth: '50%',
	},
});

export default PageHeading;
